import { render, staticRenderFns } from "./advert-logo.vue?vue&type=template&id=54a7e4b1&"
import script from "./advert-logo.vue?vue&type=script&lang=ts&"
export * from "./advert-logo.vue?vue&type=script&lang=ts&"
import style0 from "./advert-logo.vue?vue&type=style&index=0&id=54a7e4b1&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports